<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="(action == 'set' ? 'Установить' : 'Снять')" (onOk)="ok()">
	<p>{{action == 'set' ? 'Установить' : 'Снять'}} SEO-Divly метку для: <strong>{{title}}</strong>?</p>
</base-support-modal>
